import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 9416 12468"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#1c1b17}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m5079 141-80 2497h-140L4689 141h-451l-80 2497h-141L3848 141h-376l-80 2497h-141L3082 141h-256c-179 333-289 768-289 1244v1472c0 1040 522 1892 1160 1892h795c638 0 1160-852 1160-1893V1385c0-475-110-910-289-1244h-284z"
        className="fil0"
      />
      <path
        d="M4561 12181c1 154-132 281-297 283l-339 3c-164 2-297-122-296-276l71-7350c1-154 137-280 301-280h195c164 0 300 126 301 280l64 7340zM1634 12161c1 165-132 301-296 303l-339 3c-165 3-298-130-296-295l70-7847c2-164 137-299 302-299h195c164 0 300 135 301 299l63 7836z"
        className="fil0"
      />
      <path
        d="M1640 0C276 331 0 1974 0 3220v612c0 1246 578 2466 1594 3307L1640 0zM8322 12161c1 165-132 301-296 303l-340 3c-164 3-297-130-296-295l71-7847c1-164 137-299 301-299h195c165 0 300 135 301 299l64 7836z"
        className="fil0"
      />
      <path
        d="M9416 2883V1777c0-782-523-1422-1160-1423h-795c-638 1-1160 641-1160 1423v126c-3 46-5 93-5 140v1183c0 838 522 1523 1160 1523h795c638 0 1160-685 1160-1523v-213c3-43 5-86 5-130z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
